<div class="panel">
    <div class="panel__content" style="background-color: #fff">

        <mat-tab-group class="tab-container">
            <mat-tab label="Regional settings">
                <div id="user-preferences">
                    <div class="margin-b--16">
                    </div>

                    <!-- Language -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="cbLanguage" class="label">Language</label>
                            <select id="cbLanguage" placeholder="Select Language" [(ngModel)]="preferences.Language" ngDefaultControl required>
                                <option [value]="item.Id" *ngFor="let item of languages">
                                    {{item.Name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- Home Page -->
                    <!--<div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="cbHomePage" class="label">Home Page</label>
                            <select id="cbHomePage" placeholder="Select Home Page" [(ngModel)]="selectItem" ngDefaultControl required>
                                <option [value]="item" *ngFor="let item of itemList">

                                </option>
                            </select>
                        </div>
                    </div>-->

                    <!-- Colour Scheme -->
                    <!--<div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="cbColourScheme" class="label">Colour Scheme</label>
                            <select id="cbColourScheme" placeholder="Select Colour Scheme" [(ngModel)]="selectItem" ngDefaultControl required>
                                <option [value]="item" *ngFor="let item of itemList">

                                </option>
                            </select>
                        </div>
                    </div>-->

                    <!-- Currency -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="cbCurrency" class="label">Currency</label>
                            <select id="cbCurrency" placeholder="Select Currency" [(ngModel)]="preferences.Currency" ngDefaultControl required>
                                <option [value]="item.Id" *ngFor="let item of currencies">
                                    {{item.Name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- UOM -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="rgUOM" class="label">Unit of Measurement</label>
                            <mat-radio-group id="rgUOM" [(ngModel)]="selectedUOM" ngDefaultControl>
                                <mat-radio-button [value]="1" (click)="changeUOM(1)">inch</mat-radio-button>
                                <mat-radio-button [value]="2" (click)="changeUOM(2)">mm</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Contact Details">
                <div id="user-contact-details">
                    <div class="margin-b--16">
                    </div>

                    <!-- Email -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtEmail" class="label">E-mail</label>
                            <input id="txtEmail" placeholder="Email address" type="text" [(ngModel)]="preferences.Email" ngDefaultControl disabled>
                        </div>
                    </div>

                    <!-- Mobile -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtMobile" class="label">Mobile</label>
                            <input id="txtMobile" placeholder="Mobile number" type="text" [(ngModel)]="preferences.Mobile" pattern="[0-9]+" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Phone -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtPhone" class="label">Phone</label>
                            <input id="txtPhone_AreaCode" placeholder="Area" type="text" [(ngModel)]="preferences.PhoneAreaCode" pattern="[0-9]+" ngDefaultControl>
                            <input id="txtPhone" placeholder="Phone number" type="text" [(ngModel)]="preferences.PhoneNumber" pattern="[0-9]+" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Fax -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtFax" class="label">Fax</label>
                            <input id="txtFax_AreaCode" placeholder="Area" type="text" [(ngModel)]="preferences.FaxAreaCode" pattern="[0-9]+" ngDefaultControl>
                            <input id="txtFax" placeholder="Fax" type="text" [(ngModel)]="preferences.Fax" pattern="[0-9]+" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Address line 1 -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtAddress1" class="label">Address line 1</label>
                            <input id="txtAddress1" placeholder="Address" type="text" [(ngModel)]="preferences.Address" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Address line 2 -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtAddress2" class="label">Address line 2</label>
                            <input id="txtAddress2" placeholder="" type="text" [(ngModel)]="preferences.Address2" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Suburb -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtSuburb" class="label">Suburb</label>
                            <input id="txtSuburb" placeholder="Suburb" type="text" [(ngModel)]="preferences.Suburb" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Post Code -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtPostCode" class="label">Post Code</label>
                            <input id="txtPostCode" placeholder="Postcode" type="text" [(ngModel)]="preferences.PostCode" pattern="[0-9]+" ngDefaultControl>
                        </div>
                    </div>

                    <!-- State -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtState" class="label">State</label>
                            <input id="txtState" placeholder="State" type="text" [(ngModel)]="preferences.State" pattern="[a-zA-Z ]+" ngDefaultControl>
                        </div>
                    </div>

                    <!-- Country -->
                    <div class="margin-bottom-24">
                        <div class="input-container">
                            <label for="txtCountry" class="label">Country</label>
                            <input id="txtCountry" placeholder="Country" type="text" [(ngModel)]="preferences.Country" pattern="[a-zA-Z ]+" ngDefaultControl>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <br />
        <div>
            <button mat-raised-button color="warn" (click)="submitChanges()">Submit</button>
        </div>
    </div>
</div>